import { type ReactNode } from "react";

import { useDigitalDataInit } from "@/src/hooks/digitalData/useDigitalDataInit";
import { useDigitalDataResize } from "@/src/hooks/digitalData/useDigitalDataResize";
import { useDigitalDataThemeMode } from "@/src/hooks/digitalData/useDigitalDataThemeMode";
import {
  UseDigitalDataTrackerAuth,
  useDigitalDataTracker
} from "@/src/hooks/digitalData/useDigitalDataTracker";

export interface DigitalDataLayerProviderProps {
  children: ReactNode;
  locale: string;
  auth: UseDigitalDataTrackerAuth;
}

export const DigitalDataLayerProvider = ({
  children,
  locale,
  auth
}: DigitalDataLayerProviderProps) => {
  // Use custom hooks to handle different concerns
  useDigitalDataInit(locale);
  useDigitalDataResize();
  useDigitalDataTracker(locale, auth);
  useDigitalDataThemeMode();

  return <>{children}</>;
};

export default DigitalDataLayerProvider;
